import React from "react";
import { Switch } from "@/components/ui/switch";
import { MessageCircle, Mail } from "lucide-react";
import { formatDateTime } from "@/lib/datetime";

const Pill = ({ on, testid }) => (
  <span data-testid={testid} className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold ${on ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>
    {on ? "Subscribed" : "Not subscribed"}
  </span>
);

const Changed = ({ at, by }) => at ? <div className="text-[11px] text-slate-400 mt-0.5">Changed {formatDateTime(at)}{by ? ` by ${by}` : ""}</div> : null;

export function MarketingSubscriptions({ m }) {
  if (!m) return null;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 mt-4 pt-4 border-t border-slate-100" data-testid="customer-marketing-subs">
      <div>
        <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-400 flex items-center gap-1"><MessageCircle className="w-3 h-3" /> WhatsApp marketing</div>
        <div className="mt-1"><Pill on={m.whatsapp_subscribed} testid="customer-wa-subscribed" /></div>
        {m.whatsapp_blocked && <div className="text-[11px] text-rose-600 mt-0.5" data-testid="customer-wa-blocked">Opted out — this number is blocked from WhatsApp campaigns</div>}
        <Changed at={m.whatsapp_changed_at} by={m.whatsapp_changed_by} />
      </div>
      <div>
        <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-400 flex items-center gap-1"><Mail className="w-3 h-3" /> Email newsletter</div>
        <div className="mt-1"><Pill on={m.newsletter_subscribed} testid="customer-newsletter-subscribed" /></div>
        <Changed at={m.newsletter_changed_at} by={m.newsletter_changed_by} />
      </div>
    </div>
  );
}

export function MarketingToggles({ wa, newsletter, onChange, blocked, prefix }) {
  const row = (label, hint, checked, key) => (
    <label className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 px-3 py-2">
      <span><span className="text-sm font-medium text-slate-800">{label}</span><span className="block text-[11px] text-slate-400">{hint}</span></span>
      <Switch checked={!!checked} onCheckedChange={(v) => onChange(key, v)} data-testid={`${prefix}-${key}`} />
    </label>
  );
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {row("WhatsApp marketing", blocked ? "Customer opted out — campaigns stay blocked" : "Records an opt-in / opt-out for the mobile", wa, "whatsapp_subscribed")}
      {row("Email newsletter", "Customer agreed to marketing emails", newsletter, "newsletter_subscribed")}
    </div>
  );
}
